// extracted by mini-css-extract-plugin
module.exports = {"slider":"QuoteSlider_slider__gHkrB"};